import styled from "styled-components";

export const ParallaxContainer = styled.div`
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-height: 45vh;
    padding: 3rem 1.5rem;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    min-height: 38vh;
    padding: 2rem 1rem;
  }
`;

export const ParallaxText = styled.h3`
  text-align: center;
  font-size: 3rem;
  font-weight: 800;
  color: white;
  width: 90%;
  max-width: 900px;
  font-style: italic;

  @media all and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 2.5rem;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2.25rem;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 2rem;
  }

  @media all and (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    font-size: 1.75rem;
  }
`;